export const iconFontAwesomeEmojiFaceSmileBeam = (
	<i className="fa-solid fa-face-smile-beam"></i>
);
